var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// /Users/frontend-dev/Desktop/ESM/elit_stroy_front/~/babel-runtime/~/core-js/library/modules/$.core.js
// module id = 20
// module chunks = 0